import React from "react";
import CheckoutAttachmentsPickers from "components/CheckoutAttachmentsPickers";
import SectionBezel from "components/SectionBezel";
import Pill from "components/Pill";
import { STATUS, UI_THEME } from "utils/constants/ui";

const AttachmentsFields = () => {
  const action = (
    <Pill copy="Premium" theme={UI_THEME.SLIM} status={STATUS.PREMIUM} />
  );

  /**
   * Set attachments in the slots here
   * > CheckoutAttachmentPickers setup one or more slots
   * > CheckoutAttachmentPicker fill the slots
   * -- intent is show / new
   */
  return (
    <SectionBezel header="Files" expandable open={false} action={action}>
      <CheckoutAttachmentsPickers
        /**
         * Selected files are set as
         * - attachment uuids are under shortLink.data.product.attachments
         */
        rootPath="data.product"
        name="attachments"
        editMode
      />
    </SectionBezel>
  );
};

export default AttachmentsFields;
